import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import firebase from 'firebase';

class DefaultLayout extends Component {
  componentDidMount() {
    let self = this;
      let userId = localStorage.getItem('user_id');
      if (userId !== null) {
        self.userId = userId;
        let online = {};
        online['/users/' + self.userId + '/online'] = true;
        firebase.database().ref().update(online); //return not alert
        window.offline = {};
        window.offline['/users/' + self.userId + '/online'] = false;
        window.onbeforeunload = function(e){  
          e.preventDefault();
          firebase.database().ref().update(window.offline); //return not alert
        }
      }
  }
  render() {
      return (
        <div className="app">
          <AppHeader fixed>
            <DefaultHeader />
          </AppHeader>
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader />
              <AppSidebarForm />
              <AppSidebarNav navConfig={navigation} {...this.props} />
              <AppSidebarFooter />
              {/* <AppSidebarMinimizer /> */}
            </AppSidebar>
            <main className="main">
              {/* <AppBreadcrumb appRoutes={routes}/> */}
              <Container fluid>
                <Switch>
                  {routes.map((route, idx) => {
                      return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                          <route.component {...props} />
                        )} />)
                        : (null);
                    },
                  )}
                  <Redirect from="/" to="/home" />
                </Switch>
              </Container>
            </main>
            {/* <AppAside fixed hidden>
              <DefaultAside />
            </AppAside> */}
          </div>
          <AppFooter>
            <DefaultFooter />
          </AppFooter>
        </div>
      );
  }
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js